namespace C2S {

    export interface IValidateRequired {
        get_required(): boolean;
        set_required(value: boolean): void;
    }

    @Decorators.registerInterface('C2S.IValidateRequired')
    export class IValidateRequired {
    }
}